/** What a hidden salary looks like until the viewer clicks the eye. */
export const MASKED_AMOUNT = "•••• €";

export function formatSalary(value: number | string | null | undefined): string {
  if (value == null || value === "") return "";
  const n = Number(value);
  return Number.isFinite(n)
    ? `${n.toLocaleString("lt-LT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`
    : String(value);
}
